import { useEffect } from 'react';

import { BRAND_SURVEY_URL } from '../homeBannerConfig';

const WIDGET_EMBED_BASE =
  'https://eodhljnwmkphervhvhio.supabase.co/functions/v1/widget-embed';

const SCRIPT_ID = 'pesquisa-marca-indecx-embed';

function buildWidgetEmbedUrl(surveyUrl: string): string {
  const survey = new URL(surveyUrl);
  const embed = new URL(WIDGET_EMBED_BASE);

  const widgetId = survey.searchParams.get('id');
  const src = survey.searchParams.get('src');

  if (widgetId) embed.searchParams.set('widgetId', widgetId);
  if (src) embed.searchParams.set('src', src);

  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach((key) => {
    const value = survey.searchParams.get(key);
    if (value) embed.searchParams.set(key, value);
  });

  return embed.toString();
}

export default function PesquisaMarcaIndecx() {
  useEffect(() => {
    const isDesktop = window.screen.width >= 620;
    if (!isDesktop) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = buildWidgetEmbedUrl(BRAND_SURVEY_URL);
    script.async = true;
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById(SCRIPT_ID);
      if (existing?.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    };
  }, []);

  return null;
}
